import { PanwLogo } from '../../assets'
import { DISCLAIMER } from '../../constants'
import { Body } from '@panwds/react-ui'
const ScreenFooter = () => {
  return (
    <div className='tw-flex tw-flex-col tw-items-center tw-mt-auto' >
      <div className='tw-mt-3'>
        <img className='cm-w-[16px]' alt={'logo'} src={PanwLogo} />
      </div>
      <Body addClassName={'tw-mt-2'} appearance='secondary'>© {new Date().getFullYear()} {DISCLAIMER}</Body>
    </div>
  )
}

export default ScreenFooter
